import { getLocale } from '@/locales/locale';
import { constProps } from '@/pages/VASOrder/index.interface';
import $i18n from '@alife/panda-i18n';
/**
 * 根据type获取字典 --- allDict里的
 * @param type
 * filterKey 过滤in/ !in
 * @returns [{ label: '', value: '' }]
 * @example getDict('INSURANCE_TYPE')
 */
const getDict = (type: string, operate?: 'S' | 'A', filterKey = 'in', filterItem: string[] = []) => {
  const dict: string = window.sessionStorage.getItem('allDict') || '';
  if (!dict) return;

  const dictList = JSON.parse(dict || '{}')[type.toUpperCase()];
  const key = filterKey.toUpperCase();
  const defaultList = [];
  dictList?.map((e) => {
    const name = e?.name;
    const code = e?.code;
    if (filterKey && filterItem.length > 0) {
      if (key === 'IN' && filterItem.indexOf(code) > -1) {
        defaultList.push({
          label: name,
          value: code,
        });
      } else if (key === '!IN' && filterItem.indexOf(code) === -1) {
        defaultList.push({
          label: name,
          value: code,
        });
      }
    } else {
      defaultList.push({
        label: name,
        value: code,
      });
    }
  });

  if (operate === 'A') {
    defaultList.unshift({ label: '全部', value: '' });
  } else if (operate === 'S') {
    defaultList.unshift({ label: '请选择', value: '' });
  }
  return defaultList;
};

const getDictName = () => {
  return getLocale()?.includes('CN') ? 'name' : 'nameEn';
};

interface Options {
  valueName: string;
  labelName: string;
}

const getSingleDict = (type: string, options: Options = { valueName: 'code', labelName: getDictName() }) => {
  const _list = getSessionStorageDict(type);
  if (_list) {
    const dictList = _list?.map((e) => {
      return {
        ...e,
        label: e[options.labelName] || e?.name,
        value: e[options.valueName],
      };
    });
    return dictList;
  }
};

const getSessionStorageDict = (type: string) => {
  const list = window.sessionStorage.getItem(type);

  if (list && list !== 'undefined' && list?.length) {
    return JSON.parse(list) || [];
  }
  return null;
};

const improveDict = (dictList: constProps[], operate?: 'S' | 'A') => {
  if (operate === 'A') {
    dictList.unshift({ label: $i18n.get({ id: '31255238468046848.CNTM', dm: '全部' }), value: '' });
  } else if (operate === 'S') {
    dictList.unshift({ label: $i18n.get({ id: 'PleaseSelect.four_px', dm: '请选择' }), value: '' });
  }
  return dictList || [];
};

const getSessionToJson = (sessionName: string) => {
  const sessionData = window.sessionStorage.getItem(sessionName) || '{}';
  return JSON.parse(sessionData);
};

export { getDict, getSingleDict, getSessionStorageDict, improveDict, getSessionToJson };
